import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as TemplatesAction from '../actions/templates.actions';

@Injectable()
export class TemplatesEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getTemplateId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TemplatesAction.getTemplates),
        map((action: any) => {
          return this.baseService[action.apiConstants.method](action.apiConstants, {
            start: '0',
            length: '20'
          }).subscribe((templatesData: any) => {
            this.store.dispatch(
              TemplatesAction.setTemplates({
                templatesData: templatesData.results
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getTemplateData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TemplatesAction.getTemplateData),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = `${action.apiConstants.url}/${action.sid}`;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe((templateData: any) => {
            this.store.dispatch(
              TemplatesAction.setTemplateData({
                templateData: templateData
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save Template Items Data
  saveTemplateItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TemplatesAction.sentTemplates),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.saveTemplateData).subscribe(
            (templatesData: any) => {
              this.store.dispatch(TemplatesAction.updateTemplates({ templatesData: templatesData }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  //   Change default Template
  changeDefaultTemplate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TemplatesAction.changeDefaultTemplate),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((templatesData: any) => {
            this.store.dispatch(
              TemplatesAction.getTemplates({
                apiConstants: ApiConstants.getTemplates
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
}
